export const featureFlags = `
  featureFlags {
    id
    featureKey
    defaultValue
  }
`;
